import { Stack } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import Folder from '../assets/images/folder.png';
import Notepad from '../assets/images/notepad.png';
import { routeNames } from '../services/routes';
import { Icon } from '../shared/Icon';

function Desktop() {
    return (
        <Stack spacing="3rem" direction="row">
            <Link to={routeNames.portfolio}>
                <Icon src={Folder} text="portfolio" />
            </Link>

            <Link to={routeNames.cv}>
                <Icon src={Notepad} text="curriculum vitae" />
            </Link>
        </Stack>
    );
}

export default Desktop;
